var _excluded = ["appendContent", "className", "dropdownClassName", "dropdownStyle", "disabled", "hint", "itemDisabled", "itemSelected", "itemTemplate", "itemText", "itemValue", "items", "label", "maxHeight", "onSelected", "placeholder", "prependContent", "readOnly", "required", "rules", "validateOnBlur", "validationState", "medium", "useTemplateForSelectedItem", "selectedDisplayTemplate", "selectedDisplayItem"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import PropTypes from "prop-types";
import React, { forwardRef, useContext, useEffect, useRef, useState } from "react";
import AInputBase from "../AInputBase";
import { AFormContext } from "../AForm";
import AIcon from "../AIcon";
import AMenu from "../AMenu";
import { AListItem } from "../AList";
import { keyCodes } from "../../utils/helpers";
import useMenuSpacing from "../AMenuBase/hooks";
import "./ASelect.scss";
var selectCounter = 0;
var ASelect = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _inputBaseSurfaceRef$;
  var appendContent = _ref.appendContent,
    propsClassName = _ref.className,
    dropdownClassName = _ref.dropdownClassName,
    dropdownStyle = _ref.dropdownStyle,
    disabled = _ref.disabled,
    hint = _ref.hint,
    _ref$itemDisabled = _ref.itemDisabled,
    itemDisabled = _ref$itemDisabled === void 0 ? "disabled" : _ref$itemDisabled,
    _ref$itemSelected = _ref.itemSelected,
    itemSelected = _ref$itemSelected === void 0 ? "selected" : _ref$itemSelected,
    itemTemplate = _ref.itemTemplate,
    _ref$itemText = _ref.itemText,
    itemText = _ref$itemText === void 0 ? "text" : _ref$itemText,
    _ref$itemValue = _ref.itemValue,
    itemValue = _ref$itemValue === void 0 ? "value" : _ref$itemValue,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    label = _ref.label,
    maxHeight = _ref.maxHeight,
    onSelected = _ref.onSelected,
    placeholder = _ref.placeholder,
    prependContent = _ref.prependContent,
    readOnly = _ref.readOnly,
    required = _ref.required,
    rules = _ref.rules,
    validateOnBlur = _ref.validateOnBlur,
    validationState = _ref.validationState,
    medium = _ref.medium,
    _ref$useTemplateForSe = _ref.useTemplateForSelectedItem,
    useTemplateForSelectedItem = _ref$useTemplateForSe === void 0 ? false : _ref$useTemplateForSe,
    selectedDisplayTemplate = _ref.selectedDisplayTemplate,
    selectedDisplayItem = _ref.selectedDisplayItem,
    rest = _objectWithoutProperties(_ref, _excluded);
  var menuRef = useRef(null);
  var inputBaseSurfaceRef = useRef(null);
  var surfaceRef = useRef(null);
  var selectedItemRef = useRef(null);
  var _useState = useState(selectCounter++),
    _useState2 = _slicedToArray(_useState, 1),
    selectId = _useState2[0];
  var _useState3 = useState(items.find(function (x) {
      return x[itemSelected];
    })),
    _useState4 = _slicedToArray(_useState3, 2),
    originalSelectedItem = _useState4[0],
    setOriginalSelectedItem = _useState4[1];
  var _useState5 = useState(items.find(function (x) {
      return x[itemSelected];
    })),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedItem = _useState6[0],
    setSelectedItem = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isFocused = _useState8[0],
    setIsFocused = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isOpen = _useState10[0],
    setIsOpen = _useState10[1];
  var _useState11 = useState(""),
    _useState12 = _slicedToArray(_useState11, 2),
    error = _useState12[0],
    setError = _useState12[1];
  var _useState13 = useState(validationState),
    _useState14 = _slicedToArray(_useState13, 2),
    workingValidationState = _useState14[0],
    setWorkingValidationState = _useState14[1];
  var _useMenuSpacing = useMenuSpacing(surfaceRef, menuRef, maxHeight),
    checkMenuSpacing = _useMenuSpacing.checkMenuSpacing,
    menuPlacement = _useMenuSpacing.menuPlacement;
  var _useContext = useContext(AFormContext),
    register = _useContext.register,
    unregister = _useContext.unregister;
  useEffect(function () {
    setWorkingValidationState(validationState);
  }, [validationState]);
  useEffect(function () {
    if (isOpen && menuRef.current) {
      checkMenuSpacing();
      setTimeout(function () {
        menuRef.current.focus();
      }, 0);
    }
  }, [isOpen, checkMenuSpacing, menuRef]);
  useEffect(function () {
    var newSelectedItem = items.find(function (x) {
      return x[itemSelected];
    });
    if (!["string", "object"].includes(_typeof(originalSelectedItem)) && ["string", "object"].includes(_typeof(newSelectedItem)) || ["string", "object"].includes(_typeof(originalSelectedItem)) && !["string", "object"].includes(_typeof(newSelectedItem)) || typeof newSelectedItem === "string" && _typeof(originalSelectedItem) === "object" || _typeof(newSelectedItem) === "object" && typeof originalSelectedItem === "string" || typeof newSelectedItem === "string" && typeof originalSelectedItem === "string" && newSelectedItem !== originalSelectedItem || _typeof(newSelectedItem) === "object" && _typeof(originalSelectedItem) === "object" && (newSelectedItem[itemValue] !== originalSelectedItem[itemValue] || newSelectedItem[itemText] !== originalSelectedItem[itemText])) {
      setOriginalSelectedItem(newSelectedItem);
      setSelectedItem(newSelectedItem);
    }
  }, [items]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(function () {
    if (register) {
      register("a-select_".concat(selectId), {
        reset: reset,
        validate: validate
      });
    }
  }, [validationState, selectedItem, rules]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(function () {
    if (unregister) {
      return function () {
        return unregister("a-select_".concat(selectId));
      };
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var className = "a-select";
  if (propsClassName) {
    className += " ".concat(propsClassName);
  }
  if (medium) {
    className += " a-select--medium";
  }
  var getSelectedIndex = function getSelectedIndex() {
    return items.findIndex(function (item) {
      if (typeof item === "string") {
        return item === selectedItem;
      } else if (_typeof(item) === "object") {
        return selectedItem ? item[itemValue] === selectedItem[itemValue] : null;
      }
    });
  };
  var getPreviousItem = function getPreviousItem(selectedIndex) {
    if (items.every(function (x) {
      return x[itemDisabled];
    })) return null;
    var newItem = items[selectedIndex - 1];
    if (!newItem) {
      newItem = items[items.length - 1];
    }
    if (newItem[itemDisabled]) {
      return getPreviousItem(selectedIndex - 1);
    }
    return newItem;
  };
  var getNextItem = function getNextItem(selectedIndex) {
    if (items.every(function (x) {
      return x[itemDisabled];
    })) return null;
    var newItem = items[selectedIndex + 1];
    if (!newItem) {
      newItem = items[0];
    }
    if (newItem[itemDisabled]) {
      return getNextItem(selectedIndex + 1);
    }
    return newItem;
  };
  var validate = function validate() {
    var testValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : selectedItem;
    if (rules || required) {
      var workingRules = [];
      if (rules) {
        workingRules = _toConsumableArray(rules);
      }
      if (required) {
        workingRules = [{
          test: function test(v) {
            if (typeof testValue === "string") {
              return !!v || "".concat(label ? label + " is r" : "R", "equired");
            }
            if (_typeof(testValue) === "object") {
              return !!v[itemValue] || "".concat(label ? label + " is r" : "R", "equired");
            }
            return "".concat(label ? label + " is r" : "R", "equired");
          },
          level: "danger"
        }].concat(_toConsumableArray(workingRules));
      }
      setWorkingValidationState("default");
      setError(null);
      for (var i = 0; i < workingRules.length; i++) {
        var _error = workingRules[i].test(testValue);
        if (_error !== true) {
          setError(_error);
          setWorkingValidationState(workingRules[i].level || "danger");
          return {
            message: _error,
            level: workingRules[i].level || "danger"
          };
        }
      }
    }
  };
  var reset = function reset() {
    setWorkingValidationState(validationState);
    setError("");
  };
  var chevronProps = {
    className: "a-select__chevron"
  };
  var selectionProps = {
    className: "a-select__selection"
  };
  if (label) {
    selectionProps["aria-labelledby"] = "a-select__label_".concat(selectId);
  }
  if (!disabled) {
    selectionProps.ref = surfaceRef;
    selectionProps.tabIndex = 0;
    selectionProps.role = "button";
    selectionProps.onFocus = function () {
      setIsFocused(true);
    };
    selectionProps.onBlur = function (e) {
      var _menuRef$current;
      setIsFocused(false);
      !((_menuRef$current = menuRef.current) !== null && _menuRef$current !== void 0 && _menuRef$current.contains(e.relatedTarget)) && validate(selectedItem);
    };
    if (!readOnly) {
      chevronProps.onClick = selectionProps.onClick = function () {
        setIsOpen(!isOpen);
        if (!isOpen) {
          reset();
        }
      };
      if (isOpen) {
        selectionProps.className += " a-select__surface--focused";
      }
      selectionProps.onKeyDown = function (e) {
        if ([keyCodes.enter, keyCodes.space].includes(e.keyCode)) {
          e.preventDefault();
          setIsOpen(!isOpen);
        } else if (e.keyCode === keyCodes.up) {
          e.preventDefault();
          var newItem = getPreviousItem(getSelectedIndex());
          newItem && selectItem(newItem);
        } else if (e.keyCode === keyCodes.down) {
          e.preventDefault();
          var _newItem = getNextItem(getSelectedIndex());
          _newItem && selectItem(_newItem);
        }
      };
    }
  }
  var selectItem = function selectItem(item) {
    setSelectedItem(item);
    !validateOnBlur && validate(item);
    onSelected && onSelected(item);
  };
  var menuClassName = "a-select__menu-items";
  if (dropdownClassName) {
    menuClassName += " ".concat(dropdownClassName);
  }
  var menuComponentProps = {
    anchorRef: inputBaseSurfaceRef,
    className: menuClassName,
    closeOnClick: false,
    // Menu should not receive focus
    // so that the selected item can
    // be focused instead
    focusOnOpen: selectedItem ? false : true,
    onClose: function onClose() {
      setIsOpen(false);
      surfaceRef.current.focus();
    },
    open: isOpen,
    role: "listbox",
    style: _objectSpread({
      minWidth: "max-content",
      width: inputBaseSurfaceRef !== null && inputBaseSurfaceRef !== void 0 && (_inputBaseSurfaceRef$ = inputBaseSurfaceRef.current) !== null && _inputBaseSurfaceRef$ !== void 0 && _inputBaseSurfaceRef$.clientWidth ? inputBaseSurfaceRef.current.clientWidth + 2 : "auto"
    }, dropdownStyle),
    medium: medium,
    placement: menuPlacement
  };
  var selectIcon = isOpen ? "chevron-up" : "chevron-down";
  var selectionContent;
  if (selectedDisplayTemplate) {
    var itemContent = selectedDisplayItem || selectedItem;
    if (itemContent) {
      var MenuItemComponent = selectedDisplayTemplate;
      selectionContent = /*#__PURE__*/React.createElement(MenuItemComponent, {
        key: "a-select__menu-item_selectedIndex",
        item: itemContent
      });
    } else {
      selectionContent = placeholder;
    }
  } else if (!selectedItem) {
    selectionContent = placeholder;
  } else if (useTemplateForSelectedItem && itemTemplate) {
    var _MenuItemComponent = itemTemplate;
    selectionContent = /*#__PURE__*/React.createElement(_MenuItemComponent, {
      key: "a-select__menu-item_selectedIndex",
      item: selectedItem
    });
  } else if (_typeof(selectedItem) === "object") {
    selectionContent = selectedItem[itemText];
  } else if (typeof selectedItem === "string") {
    selectionContent = selectedItem;
  }
  return /*#__PURE__*/React.createElement(AInputBase, _extends({}, rest, {
    ref: ref,
    surfaceRef: inputBaseSurfaceRef,
    className: className,
    medium: medium,
    label: label,
    labelId: "a-select__label_".concat(selectId),
    onClickLabel: function onClickLabel() {
      return !disabled && surfaceRef.current.focus();
    },
    disabled: disabled,
    append: /*#__PURE__*/React.createElement(AIcon, _extends({}, chevronProps, {
      size: 16
    }), selectIcon),
    focused: isFocused || isOpen,
    readOnly: readOnly,
    validationState: workingValidationState,
    error: error,
    hint: hint,
    required: required
  }), /*#__PURE__*/React.createElement("div", {
    className: "a-select__selection-wrapper"
  }, /*#__PURE__*/React.createElement("div", selectionProps, selectionContent), /*#__PURE__*/React.createElement(AMenu, _extends({
    ref: menuRef
  }, menuComponentProps), prependContent, /*#__PURE__*/React.createElement("div", {
    className: "a-select__menu-items__wrapper".concat(maxHeight ? " overflow-y-scroll" : ""),
    style: {
      maxHeight: maxHeight
    }
  }, items.map(function (item, index) {
    var itemProps = {
      value: null,
      children: null,
      className: "a-select__menu-item",
      role: "option",
      "aria-selected": false
    };
    if (typeof item === "string") {
      itemProps.value = item;
      itemProps.children = item;
      itemProps.onClick = function () {
        setIsOpen(false);
        surfaceRef.current.focus();
        selectItem(item);
      };
      if (item === selectedItem) {
        itemProps.className += " a-select__menu-item--selected";
        itemProps["aria-selected"] = true;
        itemProps.ref = selectedItemRef;
      }
    } else if (_typeof(item) === "object") {
      itemProps.value = item[itemValue];
      itemProps.children = item[itemText];
      if (item[itemDisabled]) {
        itemProps["aria-disabled"] = true;
        itemProps.onClick = function (e) {
          e.stopPropagation();
        };
      } else {
        itemProps.onClick = function () {
          setIsOpen(false);
          surfaceRef.current.focus();
          selectItem(item);
        };
      }
      if (selectedItem && item[itemValue] === selectedItem[itemValue]) {
        itemProps.selected = true;
        itemProps.className += " a-select__menu-item--selected";
        itemProps["aria-selected"] = true;
        itemProps.ref = selectedItemRef;
      }
    }
    var MenuItemComponent = itemTemplate ? itemTemplate : AListItem;
    return /*#__PURE__*/React.createElement(MenuItemComponent, _extends({
      key: "a-select__menu-item_".concat(index)
    }, itemProps, {
      item: item,
      index: index
    }));
  })), appendContent)));
});
ASelect.propTypes = {
  /**
   * Sets the content to append to the dropdown list.
   */
  appendContent: PropTypes.node,
  /**
   * Toggles the disabled state.
   */
  disabled: PropTypes.bool,
  /**
   * Because ASelect uses an AMenu, the dropdown interface
   * is mounted outside of the application area. To style
   * this portion of ASelect, a class can be provided.
   */
  dropdownClassName: PropTypes.string,
  /**
   * Similar to the dropdownClassName prop, this can be used
   * to pass a style object to the dropdown interface
   */
  dropdownStyle: PropTypes.object,
  /**
   * Sets the hint content.
   */
  hint: PropTypes.node,
  /**
   * The property name of the value indicating a disabled option when `items` is an array of objects.
   */
  itemDisabled: PropTypes.string,
  /**
   * The property name of the value indicating a selected option when `items` is an array of objects.
   */
  itemSelected: PropTypes.string,
  /**
   * Sets a React component to use when rendering menu items. The component will be sent the following props: `item`, `index`, `aria-disabled`, `aria-selected`, `children`, `className`, `onClick`, `role`, `selected`, `value`.
   */
  itemTemplate: PropTypes.elementType,
  /**
   * The property name of the option text when `items` is an array of objects.
   */
  itemText: PropTypes.string,
  /**
   * The property name of the option value when `items` is an array of objects.
   */
  itemValue: PropTypes.string,
  /**
   * An array of select options.
   */
  items: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.object)]),
  /**
   * Sets the label content.
   */
  label: PropTypes.node,
  /**
   * Sets the max-height of the select dropdown
   * in the case of many dropdown options needing
   * overflow styling
   */
  maxHeight: PropTypes.string,
  /**
   * Handles the `selected` event.
   */
  onSelected: PropTypes.func,
  /**
   * Sets the text when no option is selected.
   */
  placeholder: PropTypes.string,
  /**
   * Sets the content to prepend to the dropdown list.
   */
  prependContent: PropTypes.node,
  /**
   * Toggles the `read-only` state
   */
  readOnly: PropTypes.bool,
  /**
   * Toggles a default rule for required values.
   */
  required: PropTypes.bool,
  /**
   * Sets validation rules for the component.
   */
  rules: PropTypes.arrayOf(PropTypes.shape({
    test: PropTypes.func,
    level: PropTypes.string
  })),
  /**
   * Delays validation until the `blur` event.
   */
  validateOnBlur: PropTypes.bool,
  /**
   * Applies a validation state.
   */
  validationState: PropTypes.oneOf(["default", "warning", "danger"]),
  /**
   * Magnetic medium size variant
   */
  medium: PropTypes.bool,
  /**
   * Use the `itemTemplate` with the selectedItem in the ASelect input.
   */
  useTemplateForSelectedItem: PropTypes.bool,
  /**
   * Sets a React component to use when rendering the selected menu item. The component will be sent the following props: `item`. This overrides `useTemplateForSelectedItem`.
   */
  selectedDisplayTemplate: PropTypes.elementType,
  /** If set, uses a custom item rather than the selectedItem when using `selectedDisplayTemplate` */
  selectedDisplayItem: PropTypes.object
};
ASelect.displayName = "ASelect";
export default ASelect;